import type { ReactNode } from 'react'
import { Info } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@teach/ui'
import { useHoverPopover } from './useHoverPopover'

/**
 * Облачко-подсказка у подписи поля: пояснение лежит под значком «i», а не печатается
 * серым текстом под полем. Открывается и наведением мыши, и нажатием: тултип по
 * одному наведению на телефоне не открывался вовсе — пальцем не наведёшь. И фокусом
 * с клавиатуры; клик мышью открытую подсказку не закрывает (`useHoverPopover`).
 */
export const FieldHint = ({ children, label }: { children: ReactNode; label: string }) => {
  const { open, setOpen, triggerProps } = useHoverPopover()
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          {...triggerProps}
          className="text-muted-foreground transition-colors hover:text-foreground focus-visible:text-foreground"
        >
          <Info className="size-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        className="w-auto max-w-xs rounded-xl bg-foreground px-3 py-1.5 text-sm leading-snug text-background"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {children}
      </PopoverContent>
    </Popover>
  )
}
